// Module
var code = `<ul class="header-connection-status__content">
	<li class="header-connection-status__item" rv-each-item="items">
		<span class="header-connection-status__time">{ item.time }</span>
		<span class="header-connection-status__message">{ item.message }</span>
	</li>
</ul>`;
// Exports
export default code;